<template>
  <div>
    <el-card class="file-permission">
      <div slot="header">
        分配权限
      </div>
      <div class="per-cont">
        <div class="file-name">
          <span>{{modalInfo.FolderName ? '文件夹名' : '文件名'}}：</span>
          <span>
              <img v-if="modalInfo.FolderId"
                  src="../../assets/images/file/folder.png"
                  alt="">
              <img v-if="modalInfo.FileExtName && fileTypeList.includes(modalInfo.FileExtName.substr(1))"
                  :src="require(`../../assets/images/file/${modalInfo.FileExtName.substr(1).toLowerCase()}.png`)"
                  alt="">
              <img v-if="modalInfo.FileExtName && !fileTypeList.includes(modalInfo.FileExtName.substr(1))" src="../../assets/images/file/no.png" alt="">
              {{modalInfo.FolderName || modalInfo.FileName}}</span>
        </div>
        <div class="file-tool">
          <div>
            <el-button type="text" icon="el-icon-plus" @click="showSelMember()">添加</el-button>
            <el-button type="text" icon="el-icon-delete">删除</el-button>
          </div>
          <!-- <el-input v-model="searchStr" type="text" place-holder="请输入..."><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input> -->
          <el-select
            v-model="searchStr"
            filterable
            remote
            placeholder="请输入关键字"
            @change="chooseMember"
            :remote-method="remoteMethod"
            reserve-keyword
            :loading="loading">
            <el-option
              v-for="item in options"
              :key="item.Id"
              :label="item.Name"
              :value="item.Name">
            </el-option>
          </el-select>
        </div>
        <div class="table-list">
          <el-table
            :data="tableInfo"
            style="width:100%"
          >
          <el-table-column
              type="selection"
              width="45">
            </el-table-column>
            <el-table-column
              label="成员"
              width="200">
              <template slot-scope="scope">
                <div>
                  {{scope.row.memberName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="权限类别">
              <template slot-scope="scope">
                <el-select v-model="scope.row.perm">
                  <el-option v-for="(i, index) in perList" :key="index" :label="i.Name" :value="i.Perm"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="开始时间">
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.origStartTime"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  placeholder="选择日期">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column
              label="结束时间">
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.origExpiredTime"
                  type="date"
                  format="yyyy 年 MM 月 dd 日"
                  placeholder="选择日期">
                </el-date-picker>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="bot-btns">
          <el-button type="primary" @click="saveAdd()">保存</el-button>
          <el-button @click="closeAdd">取消</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'filePermission',
  props: ['modalInfo'],
  data() {
    return {
      tableInfo: [],
      fileTypeList: [
        'doc', 'docx', '3gp', 'ai', 'avi', 'bmp', 'dwg', 'dxf', 'eps', 'flv', 'gif', 'jpg', 'mov', 'pptx', 'mpeg2', 'mpeg4', 'pdf', 'png', 'ppt', 'psd', 'rm', 'rmvb', 'svg', 'txt', 'webp', 'wmv', 'word', 'xls', 'xlsx', 'zip', 'jpeg'
      ],
      searchStr: [],
      perList: [],
      options: [],
      loading: false
    }
  },
  created() {
    this.getDocPermission()
  },
  computed: {
    listenAddMember() {
        return this.$store.state.addMember
    }
  },
  watch: {
    listenAddMember: function(val) {
      this.getAddInfo(val)
    }
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        this.searchMember(query)
      } else {
        this.options = [];
      }
    },
    searchMember(val) {
      let params = new FormData()
      params.append('module', 'ComponentClient')
      params.append('fun', 'Search')
      params.append('topNum', 30)
      params.append('account', '')
      params.append('realName', '')
      params.append('isChild', true)
      params.append('isLike', true)
      params.append('searchContent', val)
      params.append('allowTypes', 'Dept,Position,Group,User')
      ApiService.org.searchMember(params).then(res => {
        this.loading = false
        this.options = res.MemberList
      })
    },
    chooseMember(val) {
      let member = this.options.filter(item => {
        return item.Name.indexOf(val) > -1
      })
      this.getAddInfo(member)
      this.searchStr = ''
    },
    getAddInfo(val) {
      val.map(n => {
        n.perm = 0
        n.origStartTime = null
        n.origExpiredTime = null
        n.memberName = n.Name
      })
      this.tableInfo = this.tableInfo.concat(val)
      console.log(this.tableInfo)
    },
    getDocPermission() {
      let params = new FormData()
      params.append('module', 'DocPermissionManager')
      params.append('fun', 'GetPermCategoryList')
      params.append('language', 'zh-cn')
      ApiService.oct_doc.common(params).then(res => {
        if (this.modalInfo.FileId) {
          this.perList = res.filePermCategories
          this.loadFilePermission()
        } else if (this.modalInfo.FolderId) {
          this.perList = res.folderPermCategories
        this.loadFolderPermission()
        }
      })
    },
    loadFolderPermission() {
      let params = new FormData()
      params.append('module', 'WebClient')
      params.append('fun', 'LoadChildren')
      params.append('fid', this.modalInfo.FolderId)
      params.append('loadType', 128)
      params.append('folderViewId', '-1')
      ApiService.oct_doc.common(params).then(res => {
        let hideArr = res.hiddenPermissions
        let arr = res.permissions
        let newArr = []
        for (let i = 0; i < arr.length; i++) {
          for (let k = 0; k < hideArr.length; k++) {
            if (hideArr[k].memberType !== arr[i].memberType && hideArr[k].memberId !== arr[i].memberId) {
              newArr.push(arr[i])
            }
          }
        }
        this.tableInfo = newArr
      })
    },
    loadFilePermission() {
      let params = new FormData()
      params.append('module', 'WebClient')
      params.append('fun', 'LoadFilePermission')
      params.append('fid', this.modalInfo.FileId)
      params.append('loadType', 4)
      ApiService.oct_doc.common(params).then(res => {
        this.tableInfo = res.filepermissions
      })
    },
    showSelMember() {
      this.$store.commit('showModal', {
        name: 'addMember',
        show: true,
        top: '2rem'
      })
    },
    saveAdd() {},
    closeAdd() {
      this.$store.commit('closeModal', 'filePermission')
    }
  }
}
</script>
<style lang="scss">
.file-permission {
  .per-cont {
    width: 900px;
    min-height: 480px;
    .file-name,.file-tool {
      margin-bottom: 20px;
      display: flex;
    }
    .file-tool {
      >div {
        display: flex;
        align-items: center;
      }
      .el-select {
        margin-left: 20px;
      }
      .el-input {
        // width: 220px;
        // margin-left: 20px;
        .el-input__inner {
          height: 22px;
        }
      }
    }
    .file-name {
      span {
        font-size: 14px;
        color: #999;
      }
      span:last-child {
        display: flex;
        text-align: left;
        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
      }
    }
    .table-list {
      width: 100%;
      height: 500px;
      border: 1px solid #ccc;
      .el-table {
        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 200px;
        }
      }
    }
  }
  .bot-btns {
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mind/filePermission.vue